export default `:host {
  display: inline-flex;
  align-self: center;
  place-self: center;
  position: relative;
}

:host([type=initials]),
:host([type=image]) {
  border-radius: 24px;
}

:host([type=module]) {
  border-radius: 4px;
}

:host([type=initials][color=blue]) {
  background-color: var(--ids-color-accent-blue-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=green]) {
  background-color: var(--ids-color-accent-green-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=orange]) {
  background-color: var(--ids-color-accent-orange-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=red]) {
  background-color: var(--ids-color-accent-red-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=gray]) {
  background-color: var(--ids-color-accent-neutral-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=teal]) {
  background-color: var(--ids-color-accent-teal-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=purple]) {
  background-color: var(--ids-color-accent-purple-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=blue]) {
  background-color: var(--ids-color-accent-blue-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=green]) {
  background-color: var(--ids-color-accent-green-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=orange]) {
  background-color: var(--ids-color-accent-orange-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=red]) {
  background-color: var(--ids-color-accent-red-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=gray]) {
  background-color: var(--ids-color-accent-neutral-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=teal]) {
  background-color: var(--ids-color-accent-teal-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=purple]) {
  background-color: var(--ids-color-accent-purple-stronger);
  color: var(--ids-color-white-100);
}

.ids-avatar {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.ids-avatar[type=image], .ids-avatar[type=initials] {
  width: 48px;
  height: 48px;
}
.ids-avatar[type=module] {
  width: 28px;
  height: 20px;
  padding: 6px 2px;
}
.ids-avatar .icon-container::before {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-white-100);
  content: "";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 3px;
  z-index: 1;
}
.ids-avatar .icon-container {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -1px;
  bottom: -3px;
}
.ids-avatar .icon-container[user-status=available] {
  color: var(--ids-image-status-available-color-background);
}
.ids-avatar .icon-container[user-status=away] {
  color: var(--ids-image-status-away-color-background);
}
.ids-avatar .icon-container[user-status=busy] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container[user-status=do-not-disturb] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container[user-status=unknown] {
  color: var(--ids-image-status-unknown-color-background);
}
.ids-avatar .icon-container[user-status=meeting] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container ids-icon {
  z-index: 1;
}
.ids-avatar .icon-container::after {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
  content: "";
  width: 16px;
  height: 16px;
  left: 1px;
  top: 1px;
}

.ids-avatar-image {
  min-width: 48px;
  max-width: 48px;
  width: 48px;
  height: 48px;
  border-radius: var(--ids-image-initials-border-radius);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
